import React from "react";
import { Box, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ScreenshotLangPicker from "../../../components/ScreenshotLangPicker";
import {
    appendScreenshotLang,
    screenshotSceneKey,
    useScreenshotTranslation,
} from "../../../lib/screenshotI18n";
import { JIGSAW_SCREENSHOT_SCENES } from "../screenshotScenes";
import { screenshotPath } from "../routes";
import {
    formatScreenshotAccessExpiredLabel,
    formatScreenshotAccessValidThroughLabel,
    isScreenshotAccessExpired,
} from "../lib/screenshotAccess";
import { jigsawMobileAccent, phoneShellSx } from "../styles/mainStyles";

/**
 * Screenshot index — one link per scene.
 */
export default function MainPage() {
    const { t, lang } = useScreenshotTranslation();
    const expired = isScreenshotAccessExpired();

    return (
        <Box sx={{ ...phoneShellSx, px: 2, pb: 4 }}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1, mb: 1 }}>
                <ScreenshotLangPicker />
            </Box>
            <Typography variant="h5" sx={{ fontWeight: 800, mb: 0.5, color: jigsawMobileAccent }}>
                {t("mobileScreenshot.jigsaw.title")}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {expired
                    ? formatScreenshotAccessExpiredLabel()
                    : formatScreenshotAccessValidThroughLabel()}
            </Typography>

            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
                {t("mobileScreenshot.common.screenshots-title", "Screenshots")}
            </Typography>
            <Stack spacing={1}>
                {JIGSAW_SCREENSHOT_SCENES.map((scene) => {
                    const label = t(screenshotSceneKey("jigsaw", scene.slug, "label"));
                    if (expired) {
                        return (
                            <Typography
                                key={scene.slug}
                                variant="body2"
                                sx={{ color: "text.disabled", fontWeight: 600 }}
                            >
                                {t("mobileScreenshot.common.scene-link", { slug: scene.slug, label })}{" "}
                                {t("mobileScreenshot.common.scene-expired")}
                            </Typography>
                        );
                    }
                    return (
                        <Link
                            key={scene.slug}
                            component={RouterLink}
                            to={appendScreenshotLang(screenshotPath(scene.slug), lang)}
                            underline="hover"
                            sx={{ color: jigsawMobileAccent, fontWeight: 600 }}
                        >
                            {t("mobileScreenshot.common.scene-link", { slug: scene.slug, label })}
                        </Link>
                    );
                })}
            </Stack>
        </Box>
    );
}
